import { combineReducers } from 'redux';
import types from './types';

/* State Shape
{
    isCashOutModalShowing: bool,
    isSupportDetailsModalShowing: bool,
    isShowingHowSponsorshipsWorksModal: bool,
    campaigns: [
    ]
}
*/

const isCashOutModalShowingReducer = (state = false, action) => {
  switch (action.type) {
    case types.OPEN_CASH_OUT_MODAL:
      return true;
    case types.CLOSE_CASH_OUT_MODAL:
      return false;
    default:
      return state;
  }
};

const isSupportDetailsModalShowingReducer = (state = false, action) => {
  switch (action.type) {
    case types.OPEN_SUPPORT_DETAILS_MODAL:
      return true;
    case types.CLOSE_SUPPORT_DETAILS_MODAL:
      return false;
    default:
      return state;
  }
};

const campaignsReducer = (state = [], action) => {
  switch (action.type) {
    case types.SET_CAMPAIGNS:
      return action.payload.campaigns;
    default:
      return state;
  }
};

const isFetchingCampaignsReducer = (state = false, action) => {
  switch (action.type) {
    case types.FETCH_CAMPAIGNS_START:
      return true;
    case types.FETCH_CAMPAIGNS_FAILURE:
    case types.FETCH_CAMPAIGNS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const isShowingHowSponsorshipsWorksModalReducer = (state = false, action) => {
  switch (action.type) {
    case types.SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL:
      return action.payload.isShowingHowSponsorshipsWorksModal;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isCashOutModalShowing: isCashOutModalShowingReducer,
  isFetchingCampaigns: isFetchingCampaignsReducer,
  isSupportDetailsModalShowing: isSupportDetailsModalShowingReducer,
  campaigns: campaignsReducer,
  isShowingHowSponsorshipsWorksModal: isShowingHowSponsorshipsWorksModalReducer,
});

export default reducer;
